export default __webpack_public_path__ + "6496f3df4c982273fa2f75bf00ee4b69.svg";